<template>
  <v-card
          min-height="500px" min-width="1100px"
          elevation="0"
  >
    <UnityTemplatePackConfig/>
  </v-card>
</template>

<script>
  import UnityTemplatePackConfig from '@/unity-service-dashboard/modules/UnityTemplatePackConfig';

  export default {
    name: "AutomatePackSettingPopup",
    components: {
      UnityTemplatePackConfig
    }
  }
</script>

<style scoped>

</style>